import {Component, OnInit} from '@angular/core';
import {Page} from '../../../../global/util/enum/Page';
import {NgbActiveModal, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from '../../../service/auth/auth.service';
import {Constant} from '../../../../global/util/Constant';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {Dialog} from '../../../../global/util/Dialog';
import {InformType} from '../../../../global/util/enum/InformType';
import {SignatureReportService} from '../../../service/signature-report.service';
import {Service} from '../../../../global/util/Service';
import {NgbDateStructUtil} from '../../../../global/util/NgbDateStructUtil';
import {CustomDateParserFormatter} from '../../balance/view-balance/view-balance.component';
import {SecondDetail} from '../../../model/SecondDetail';
import {FirstDetail} from '../../../model/FirstDetail';
import {TranslateService} from '@ngx-translate/core';
import {Pagination} from '../../../../global/util/Pagination';

@Component({
  selector: 'app-detail-signature-report',
  templateUrl: './detail-signature-report.component.html',
  styleUrls: ['./detail-signature-report.component.css'],
  providers: [{provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter}]
})
export class DetailSignatureReportComponent implements OnInit {

  public title = 'TITLE.DETAIL-CONSUMPTION-OF-SERVICES';
  public detailSignatureReports: SecondDetail[] = [];
  public signatureReport: FirstDetail;
  public page: any = {};
  public links: any = {};
  public enumPage = Page;
  public loading: boolean;
  public from: any;
  public to: any;
  public serviceId: number;
  public serviceName: string;
  pageNumber: any;
  pageNumbers: any[] = [];

  constructor(public signatureReportService: SignatureReportService,
              public formatter: NgbDateParserFormatter,
              public activeModal: NgbActiveModal,
              public authService: AuthService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[Constant.ZERO_INDEX].value;
    this.search();
  }

  public loadDetails(page: Page): void {
    let url;
    let operation;
    if (this.signatureReport.operation === undefined) {
      operation = 0;
    } else {
      operation = this.signatureReport.operation;
    }
    switch (page) {
      case Page.First:
        url = Constant.ROOT_API_V1.concat('/secondReportDetail/search?',
          '&enterpriseId=', String(this.signatureReport.enterpriseId),
          '&workflowId=', String(this.signatureReport.workflowId),
          '&serviceId=', String(this.serviceId),
          '&operationId=', String(operation),
          '&year=', String(this.signatureReport.year),
          '&month=', String(this.signatureReport.monthNumber),
          '&dateFrom=', NgbDateStructUtil.toString2YYYYMMdd(this.from),
          '&dateTo=', NgbDateStructUtil.toString2YYYYMMdd(this.to),
          '&size=' + this.pageNumber + '&sort=id,desc');
        break;
      case Page.Previous:
        url = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        url = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        url = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        url = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    this.getDetails(url);
  }

  private getDetails(url: string): void {
    this.loading = true;
    this.signatureReportService.get(url).subscribe((next: any) => {
      this.loading = false;
      if (next._embedded) {
        this.detailSignatureReports = next._embedded.signatureReportDetailModelList;
      } else {
        this.detailSignatureReports = [];
      }
      this.page = next.page;
      this.links = next._links;
    }, error => {
      this.loading = false;
      this.title = this.translate.instant('TITLE.DETAIL-CONSUMPTION-OF-SERVICES');
      if (HttpStatusCode.UNAUTHORIZED === error.error.status) {
        Dialog.show(InformType.Danger, this.title, error.error.message);
      } else {
        Dialog.show(InformType.Danger, this.title);
      }
    });
  }

  public hasRole(name: string): boolean {
    return this.authService.hasRole(name);
  }

  public hasAuthority(code: string): boolean {
    return this.authService.hasAuthority(code);
  }

  accept() {
    this.activeModal.close();
  }

  search(): void {
    this.loadDetails(Page.First);
  }

  public downloadOf() {
    let operation;
    if (this.signatureReport.operation === undefined) {
      operation = 0;
    } else {
      operation = this.signatureReport.operation;
    }
    const url = Constant.ROOT_API_V1.concat('/secondReportDetail/download?',
      '&enterpriseId=', String(this.signatureReport.enterpriseId),
      '&workflowId=', String(this.signatureReport.workflowId),
      '&serviceId=', String(this.serviceId),
      '&operationId=', String(operation),
      '&year=', String(this.signatureReport.year),
      '&month=', String(this.signatureReport.monthNumber),
      '&dateFrom=', NgbDateStructUtil.toString2YYYYMMdd(this.from),
      '&dateTo=', NgbDateStructUtil.toString2YYYYMMdd(this.to));
    this.signatureReportService.getReportOf(url).subscribe(next => {
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      control.download = this.translate.instant('TITLE.REPORT-DETAIL-FINAL');
      control.click();
      this.loading = false;
    }, error => {
      const title = this.translate.instant('TITLE.DOWNLOAD-DOCUMENTS');
      this.processError(title, error);
    });
  }

  private processError(title: string, error: any) {
    const status = error.status;
    this.title = this.translate.instant('TITLE.DETAIL-CONSUMPTION-OF-SERVICES');
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
      } else {
        Dialog.show(InformType.Danger, title);
      }
    } else {
      Dialog.show(InformType.Danger, title, error.error.message);
    }
  }

  public isSendElectronicNotificationService(): boolean {
    return this.serviceId === Service.SEND_ELECTRONIC_NOTIFICATION;
  }

  public isSendEmailService(): boolean {
    return this.serviceId === Service.SEND_EMAIL;
  }

  public getOperation(): string {
    if (this.serviceId === Service.NOTCER) {
      return 'TABLE.HEADER.NOTIFIER';
    } else {
      return 'TABLE.HEADER.SIGNER';
    }
  }

  public getDescriptionDate(): string {
    if (this.serviceId === Service.NOTCER || this.signatureReport.operation === 4) {
      return 'TABLE.HEADER.SIGNATURE-NOTIFY';
    } else {
      if (this.signatureReport.operation === 3) {
        return 'TABLE.HEADER.SIGNATURE-ACKNOWLEDGMENT';
      } else {
        return 'TABLE.HEADER.SIGNATURE-DATE';
      }
    }
  }
}
